<main >
  <div class="openMenu" (click)="abrirMenu()" >
    <tgt-perfil [size]="'small'" ></tgt-perfil >
    <div class="title-mobile" >
      @if (role?.id === PermissaoEnum.ROLE_RESPONSAVEL) {
        @if (user) {
          <h2 >Olá {{ user.name }}</h2 >
        } @else {
          <h2 >Olá</h2 >
        }
      } @else {
        <h2 >{{ title | async }}</h2 >
      }
    </div >
  </div >

  @if (isMenu) {
    <div class="menu" >
      <div class="menu-content" >
        <div class="header-menu" >
          <span class="material-symbols-outlined close" (click)="abrirMenu()" >close</span >
          <p >Menu</p >
          <div ></div >
        </div >
        <div class="itens-menu" >

          <span >Olá {{ user.name }} !</span >

          <p >Dados do Usuário</p >

          <div class="card" (click)="irParaPerfil()" >
            <p >Dados do Perfil</p >
            <span class="material-symbols-outlined" >
            chevron_right
          </span >
          </div >

          <div class="card" (click)="abrirModalAlterarSenha()" >
            <p >Alterar Senha</p >
            <span class="material-symbols-outlined" >
            chevron_right
          </span >
          </div >

          <div class="card" (click)="irParaTermos()" >
            <p >Termos de Uso e Políticas de Privacidade</p >
            <span class="material-symbols-outlined" >
            chevron_right
          </span >
          </div >


        </div >
        <div class="logout" >
          <button (click)="logout()" >
          <span class="material-symbols-outlined" >
            logout
          </span >
            <p >Sair do Aplicativo</p >
          </button >
        </div >
      </div >
    </div >
  }

  <div class="title" >
    @if (role?.id === PermissaoEnum.ROLE_RESPONSAVEL) {
      @if (user) {
        <h2 >Olá {{ user.name }}</h2 >
      } @else {
        <h2 >Olá</h2 >
      }
    } @else {
      <h2 >{{ title | async }}</h2 >
    }
  </div >


  <div class="final" >
    <tgt-button *roles="['PROFESSOR']" (click)="abrirModalChamada()" [size]="'small'" [border]="false"
                [color]="'secundary'" >Realizar Chamada
    </tgt-button >

    <div class="desk" >
      <div class="info" (click)="abrirNotificacoes()" >
        <div class="infos" >{{ unreadNotificationsCount }}</div >
      </div >
      <span class="material-symbols-outlined pointer notifications-icon" (click)="abrirNotificacoes()" >
        notifications
        <span class="notification-dot" *ngIf="showNotificationDot && unreadNotificationsCount > 0" ></span >
      </span >

      <div class="divider-vertical" ></div >

      <div class="user pointer" >
        <button (click)="abrirModalPerfil()" >
          @if (role?.id !== PermissaoEnum.ROLE_RESPONSAVEL) {
            <p >{{ user.name }} ({{ role?.label }}) </p >
          } @else {
            <p >{{ alunoSelecionado.nomeAluno }} </p >
          }
          <span class="material-symbols-outlined" >
            swap_horiz
          </span >
        </button >
        <tgt-perfil (click)="showHideDetail()" ></tgt-perfil >

        @if (isDetail) {
          <span (click)="showHideDetail()" class="material-symbols-outlined none" >
          expand_less
        </span >
        } @else {
          <span (click)="showHideDetail()" class="material-symbols-outlined none" >
          keyboard_arrow_down
        </span >

        }
      </div >
    </div >

    <!-- <div class="mobile">
      <button (click)="abrirModalEscolherAluno()">
        <p>{{alunoSelecionado}}</p>
        <span class="material-symbols-outlined">
          swap_horiz
        </span>
      </button>
      <div class="divider-vertical"></div>
      <span (click)="abrirNotificacoes()" class="material-symbols-outlined pointer notifications-icon">
        notifications
        <span class="notification-dot" *ngIf="showNotificationDot"></span>
      </span>
    </div> -->
  </div >

  @if (isDetail) {
    <div class="fade" (click)="showHideDetail()" >
      <div class="user-detail" >
        <div class="name-profile" >
          <div class="infos" >
            <span >{{ user.name }}</span >
            <p >{{ user.email }}</p >
          </div >
          <div class="sair" >
            <!-- <span class="material-symbols-outlined">
            logout
            </span> -->
          </div >
        </div >
        <!-- <app-tabs [width]="true" (change)="changeTab($event)" [tabs]="tabs"></app-tabs> -->
        <!-- @switch (tab) {
        @case ('perfil') { -->
        <div class="item" (click)="visualizarPerfil()" >
        <span class="material-symbols-outlined" >
          person_4
        </span >
          <span class="label" >Ver Perfil</span >
        </div >
        <div class="item" (click)="visualizarPerfil()" >
        <span class="material-symbols-outlined" >
          edit
        </span >
          <span class="label" >Editar Perfil</span >
        </div >
        <!-- }
        @case ('configuracoes') { -->
        <div class="item" >
        <span class="material-symbols-outlined" >
          manage_accounts
        </span >
          <span class="label" >Configurações</span >
        </div >
        <div class="item" (click)="irParaTermos()" >
        <span class="material-symbols-outlined" >
          lock
        </span >
          <span class="label" >Termos de Uso</span >
        </div >
        <!-- }
        } -->

        <div class="item logout" (click)="logout()" >
        <span class="material-symbols-outlined" >
          logout
        </span >
          <span class="label" >Sair</span >
        </div >
      </div >
    </div >
  }

  @if (newNotification) {
    <div class="fade-notifications" (click)="abrirNotificacoes()" >
      <div class="notifications" >
        <div class="content" >
          <div class="header" >
            <span >Notificações</span >
            <p (click)="marcarTodasLidas()" >Marcar como lido</p >
          </div >
          <div class="cards" (click)="irParaPerfil()" >
          <span class="material-symbols-outlined" >
            group_add
          </span >
            <div class="text" >
              <p class="label" >Primeiro Acesso?</p >
              <span >Que tal redefinir sua senha !</span >
            </div >
          </div >
          <div class="cards" >
          <span class="material-symbols-outlined" >
            done_all
          </span >
            <div class="text" (click)="irParaPerfil()" >
              <p class="label" >Finalize seu Cadastro !</p >
              <span >Adicione suas informações !</span >
            </div >
          </div >

          @for (item of notifications; track item) {
            <div class="cards" >
          <span class="material-symbols-outlined" >
            done_all
          </span >
              <div class="text" >
                <p class="label" >{{ item.title }}</p >
                <span >{{ item.message }}</span >
              </div >
            </div >
          }
        </div >
      </div >
    </div >
  }

</main >
